<main class="content-wrapper">
  <router-outlet class="router"></router-outlet>
</main>